

import Image from 'components/Image';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import { PROFILE_PLACEHOLDER_IMAGE_PATH } from 'utils/constants/image-paths';

const PROFILE_WIDTH = 44;
const PROFILE_HEIGHT = 44;

const Company = ({ src, alt }) => (
  <>
    <Image
      src={src}
      alt={alt}
      width={`${PROFILE_WIDTH}px`}
      height={`${PROFILE_HEIGHT}px`}
      //className="center-provider provider-border-radius"
      className="provider-border-radius streaming-provider"
      loadingUI={
        // MEMO: reserve space for preventing layout shifting
        <div
          style={{
            width: `${PROFILE_WIDTH}px`,
            height: `${PROFILE_HEIGHT}px`,
          }}
          className="loading-ui streaming-provider"
          //className="loading-ui center-provider"
        >
          <LoadingSpinner />
        </div>
      }
      placeholderPath={PROFILE_PLACEHOLDER_IMAGE_PATH}
    />
    <style jsx>{`
      .loading-ui {
        display: flex;
        justify-cotent: center;
        align-items: center;
      }

      :global(.center-provider) {
        margin: 0 auto;
      }

      :global(.streaming-provider) {
        /*margin: 0 auto;*/
      }

      :global(.provider-border-radius) {
        border-radius: 25%;
      }
    `}</style>
  </>
);

export default Company;
